import { useUserContext } from 'UserContext';

export function useOpenMessaging() {
    const { user } = useUserContext();
    return (user?.businesses_active ?? []).some((business) => business.open_messaging);
}
